import { createAsyncThunk } from "@reduxjs/toolkit";
import DefaultApiService from "../../infrastructure/api/default";

export const fetchAlarmList = createAsyncThunk(
  "ui/fetchAlarmList",
  async (_, thunkAPI) => {
    try {
      const res = await DefaultApiService.getApi("UM/Alarm/GetActiveList");
      if (res.data.length) {
        return res.data;
      }
      return [];
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateAlarmStatus = createAsyncThunk(
  "ui/updateAlarmStatus",
  async (id, thunkAPI) => {
    try {
      const res = await DefaultApiService.getApi("UM/Alarm/UpdateStatusById", {
        id: id,
      });
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue();
    }
  }
);
